import { Stack } from "@similarweb/ui-components/foundations";

import { TrafficSourceTabs, useSelectedTrafficSource } from "../../traffic-sources-tabs";

import { ShareOfWebsiteTrafficTable } from "./share-of-website-traffic-table/ShareOfWebsiteTrafficTable";

export const ShareOfWebsiteTraffic = () => {
    const { value } = useSelectedTrafficSource();

    return (
        <Stack flexGrow="1">
            <TrafficSourceTabs />
            <ShareOfWebsiteTrafficTable trafficSource={value} />
        </Stack>
    );
};
